<template>
  <div class="home">
    <div v-if="tdtLoadError" id="tdt-error-banner">
      <b>地图瓦片加载失败</b> — 请登录
      <a href="https://console.tianditu.gov.cn/api/key" target="_blank">天地图控制台</a>
      将域名 <code>{{ currentHostname }}</code> 加入密钥白名单后刷新页面
      <button @click="retryLoadMap">重试</button>
    </div>
    <div id="tdtMap" class="bm-view"></div>
    <div class="change2-scale">
      <div @click="scaleMin()"
           style="width: 30px;height: 30px;border-radius: 50%;border:2px solid #1D2693; color: #1D2693;font-size: 50px;line-height: 23px;text-align: center;">
        -
      </div>
      <div @click="scaleMax()"
           style="width: 30px;height: 30px;border-radius: 50%;border:2px solid #1D2693; color: #1D2693;font-size: 40px;margin-top: 15px;line-height: 24px;text-align: center;">
        +
      </div>
    </div>
    <div class="change" @click="change">「切换」</div>
    <div class="head-wrap">
      <div class="head bg-color">

        <div class="address-wrap">
          <img class="address-img" src="../assets/image/home/address.png" alt=""/>
          <div class="address-text">{{ city ? city : '广东省深圳市' }}</div>
        </div>

        <div class="head-title">
          <img class="head-flag-img" src="../assets/image/home/head-flag.png" alt=""/>
          <div class="head-title-text">秒秒物联管理云平台</div>
        </div>

        <div class="time-wrap">
          <div class="time">{{ newData }} {{ week }}</div>
          <!-- <div class="screen" @click="screen">「 {{ fullscreen ? "退出" : title }} 」</div> -->
        </div>

      </div>
    </div>

    <div class="hide-arrow-left" v-show="hideArrowStatus" @click="openMenu">
      <div class="left-triangle"></div>
    </div>
    <div class="hide-arrow-right" v-show="hideArrowStatus" @click="openMenu">
      <div class="right-triangle"></div>
    </div>

    <div class="left bg-color" v-show="isShow" @mouseenter="menuOver" @mouseleave="menuLeave">
      <div class="show-arrow-left" v-show="showArrowStatus" @click="closeMenu">
        <div class="left-triangle-show"></div>
      </div>

      <div class="box-content">
        <div class="box-title">平台信息</div>
        <div class="box-list">
          <div class="box-list-item-wrap member-top">
            <div class="box-list-item">
              <div class="box-list-item-name">设备总数</div>
              <div class="box-list-item-number">{{ device_list.total }}</div>

            </div>
            <div class="box-list-item">
              <div class="box-list-item-name">门店总数</div>
              <div class="box-list-item-number">{{ device_list.store_total }}</div>
            </div>
          </div>
          <div class="box-list-item-wrap member-top">
            <div class="box-list-item">
              <div class="box-list-item-name">会员总数</div>
              <div class="box-list-item-number">{{ member_info.member_total }}</div>
            </div>
            <div class="box-list-item">
              <div class="box-list-item-name">消费会员</div>
              <div class="box-list-item-number">{{ member_info.consume_member }}</div>
            </div>
          </div>
          <div class="box-list-item-wrap">
            <div class="box-list-item">
              <div class="box-list-item-name">新增会员</div>
              <div class="box-list-item-number">{{ member_info.new_member }}</div>
            </div>
            <div class="box-list-item">
              <div class="box-list-item-name">活跃会员</div>
              <div class="box-list-item-number">{{ member_info.active_member }}</div>
            </div>
          </div>

        </div>

      </div>
      <div class="box-content">
        <div class="box-title-wrap">
          <div class="box-title">设备信息</div>
          <div class="box-total-wrap">
            <div class="box-total-left">总数：{{ device_list.total }}</div>
            <div>运行：{{ device_list.run }}</div>
          </div>
        </div>
        <div class="box-graphical">
          <div id="equipment"></div>
        </div>
      </div>
      <div class="box-content">
        <div class="box-title-wrap">
          <div class="box-title">门店设备分布信息</div>
          <!-- <div class="box-total-wrap">
            <div class="box-total-left">总数：{{city_device_info.total}}</div>
            <div>运行：{{city_device_info.run}}</div>
          </div> -->
        </div>
        <div class="box-graphical">
          <div id="region"></div>
        </div>
      </div>
    </div>

    <div class="main">
      <div class="type-wrap">
        <!--        <div class="type-item-title-1" :class="index == 1 ? 'show' : ''">钢琴</div>-->
        <!--        <div class="type-item-title-2" :class="index == 2 ? 'show' : ''">跑步机</div>-->
        <!--        <div class="type-item-title-3" :class="index == 3 ? 'show' : ''">广告机</div>-->
        <!--        <div class="type-item-title-4" :class="index == 4 ? 'show' : ''">陪护床</div>-->
        <!--        <div class="type-item-title-5" :class="index == 5 ? 'show' : ''">洗车机</div>-->
        <!--        <div class="type-item-title-6" :class="index == 6 ? 'show' : ''">共享充电</div>-->
        <!--        <div class="type-item-title-7" :class="index == 7 ? 'show' : ''">电机监控</div>-->
        <!--        <div class="type-item-title-8" :class="index == 8 ? 'show' : ''">量子仪</div>-->
        <!--        <div class="type-item-title-9" :class="index == 9 ? 'show' : ''">自动售货机</div>-->
        <div v-for="(item,index1) in datanrec" :key="index1" class="type-item" @click="typeClick(item.id,index1)"
             :class="(clickIndex == index1) ? 'type-item-active' : ''">
          <el-tooltip class="item" effect="dark" :content="item.name" placement="top">
            <div class="type-item-bg-img" :style="{'background-image':'url(' + item.icon + ')' }"></div>
          </el-tooltip>
        </div>
      </div>
    </div>

    <div class="right bg-color" v-show="isShow" @mouseenter="menuOver" @mouseleave="menuLeave">
      <div class="show-arrow-right" v-show="showArrowStatus" @click="closeMenu">
        <div class="right-triangle-show"></div>
      </div>

      <div class="box-content">
        <div class="box-title-wrap">
          <div class="box-title">营业信息</div>
          <div class="box-total-wrap">
            <div class="box-total-left">总收益：{{ order_info.order_total }}元</div>
            <div>年收益：{{ order_info.year_order_total }}元</div>
          </div>
        </div>
        <div class="box-list">
          <div class="business-item business-top">
            <el-row>
              <el-col :span="6">
                <div>今日订单：{{ order_info.today_order_count }}</div>
              </el-col>
              <el-col :span="6">
                <div>本周订单：{{ order_info.week_order_count }}</div>

              </el-col>
              <el-col :span="6">
                <div>本月订单：{{ order_info.month_order_count }}</div>
              </el-col>
              <el-col :span="6">
                <div>本年订单：{{ order_info.year_order_count }}</div>
              </el-col>
            </el-row>
          </div>
          <!--          <div class="business-item">-->
          <!--            <div>今日金额：¥{{order_info.today_order_money}}</div>-->
          <!--            <div>本周金额：¥{{order_info.week_order_money}}</div>-->
          <!--            <div>本月金额：¥{{order_info.month_order_money}}</div>-->
          <!--          </div>-->
          <div class="business-item">
            <el-row>
              <el-col :span="6">
                <div>今日营收：¥{{ order_info.today_order_revenue }}</div>
              </el-col>
              <el-col :span="6">
                <div>本周营收：¥{{ order_info.week_order_revenue }}</div>

              </el-col>
              <el-col :span="6">
                <div>本月营收：¥{{ order_info.month_order_revenue }}</div>

              </el-col>
              <el-col :span="6">
                <div>本年营收：¥{{ order_info.year_order_revenue }}</div>

              </el-col>
            </el-row>
          </div>
          <div class="business-item">
            <el-row>
              <el-col :span="6">
                <div>今日余额：¥{{ order_info.today_balance }}</div>
              </el-col>
              <el-col :span="6">
                <div>累计余额：¥{{ order_info.sum_balance }}</div>
              </el-col>
              <el-col :span="6">
                <div>今日权益：¥{{ order_info.today_card_money }}</div>
              </el-col>
              <el-col :span="6">
                <div>累计权益：¥{{ order_info.sum_card_money }}</div>
              </el-col>
            </el-row>
            <!--            <div>本月新增：¥200</div>-->
          </div>
        </div>
      </div>
      <div class="box-content">
        <div class="box-title-wrap">
          <div class="box-title">订单列表</div>
          <div class="box-total-wrap">
            <!-- <div class="box-total-left">今日：2万元</div>
            <div>本月：10万元</div> -->
          </div>
        </div>
        <div class="box-list">

          <div class="order-head">
            <div class="order-head-item">用户</div>
            <div class="order-head-item">类型</div>
            <div class="order-head-item">消费金额</div>
            <div class="order-head-item">消费时间</div>
          </div>

          <div class="order-list">
            <vue-seamless-scroll :data="orderInfoList" class="seamless-warp">
              <div class="order-list-row" v-for="(item, index) in orderInfoList" :key="index">
                <div>{{ item.name }}</div>
                <div>{{ item.device_type }}</div>
                <div>{{ item.money }}</div>
                <div>{{ item.time }}</div>
              </div>
            </vue-seamless-scroll>
          </div>


        </div>
      </div>
      <div class="box-content">

        <div class="box-title-wrap">
          <div class="box-title">订单趋势</div>
          <!-- <div class="box-total-wrap">
            <div>消费：<span class="consume">2万元</span></div>
            <div class="box-total-recharge">充值：<span class="recharge">3万元</span></div>
            <div>订单：<span class="order">2万元</span></div>
          </div> -->
        </div>
        <div class="order-trend-wrap">
          <div id="order-trend"></div>
        </div>

      </div>
    </div>

  </div>
</template>
<script>
import * as echarts from "echarts";
import vueSeamlessScroll from 'vue-seamless-scroll'
//import DevicePixelRatio from '@/devicePixelRatio';
export default {
  data() {
    return {
      lng: 114.06455184,
      lat: 22.54845664,
      city: '',
      datanrec: [],
      /*
      *img_black_1: require('@/assets/image/home/t-black-1.png'),
        img_black_2: require('@/assets/image/home/t-black-2.png'),
        img_black_3: require('@/assets/image/home/t-black-3.png'),
        img_black_4: require('@/assets/image/home/t-black-4.png'),
        img_black_5: require('@/assets/image/home/t-black-5.png'),
        img_black_6: require('@/assets/image/home/t-black-6.png'),
        img_black_7: require('@/assets/image/home/t-black-7.png'),
        img_black_8: require('@/assets/image/home/t-black-8.png'),
        img_black_9: require('@/assets/image/home/t-black-9.png'),
        { lat: 39.89575, lng: 116.28988, styleId: 't2' },
        { lat: 39.97653, lng: 116.46142, styleId: 't3' },
        { lat: 39.98653, lng: 116.47142, styleId: 't4' },
        { lat: 40.00435, lng: 116.26792, styleId: 't5' },
        { lat: 40.02635, lng: 116.26992, styleId: 't6' },
        { lat: 39.81983, lng: 116.31502, styleId: 't7' },
        { lat: 39.83183, lng: 116.35402, styleId: 't8' },
        { lat: 39.83283, lng: 116.31502, styleId: 't9' },
      */
      points: [
        //   {
        //     lng:'114.06455184',
        //     lat:'22.66375',
        //     src:require('@/assets/image/home/t-black-1.png'),
        // },
        // {
        //     lng:'114.06142',
        //     lat:'22.67653',
        //     src:require('@/assets/image/home/t-black-2.png'),
        // },
        // {
        //     lng:'114.16792',
        //     lat:'22.58653',
        //     src:require('@/assets/image/home/t-black-3.png'),
        // },
        // {
        //     lng:'114.16792',
        //     lat:'22.68435',
        //     src:require('@/assets/image/home/t-black-4.png'),
        // },
        // {
        //     lng:'114.16792',
        //     lat:'22.58635',
        //     src:require('@/assets/image/home/t-black-5.png'),
        // },
        // {
        //     lng:'114.21502',
        //     lat:'22.581983',
        //     src:require('@/assets/image/home/t-black-6.png'),
        // },
        // {
        //     lng:'114.15402',
        //     lat:'22.458183',
        //     src:require('@/assets/image/home/t-black-7.png'),
        // },
        // {
        //     lng:'114.131502',
        //     lat:'22.68283',
        //     src:require('@/assets/image/home/t-black-8.png'),
        // },
      ],
      active: false,
      member_info: {},
      device_list: {},
      device_Data_name: [],
      city_device_info: {},
      city_Data_name: [],
      order_info: {},
      newData: '',
      week: '',
      index: 0, //鼠标滑过图标
      map: '',
      markerList: [], //天地图标注实例列表
      skinStatus: true, //默认白色皮肤
      tdtLoadError: false,
      currentHostname: window.location.hostname || 'localhost',
      isShow: true,
      fullscreen: false,
      title: "全屏",
      showArrowStatus: false,
      hideArrowStatus: false,
      orderInfoList: [
        // { id: '1', name: '张依依1', type: '洗车机', money: 50, time: '2022-08-02' },
        // { id: '2', name: '张依依2', type: '洗车机', money: 50, time: '2022-08-02' },
        // { id: '3', name: '张依依3', type: '洗车机', money: 50, time: '2022-08-02' },
        // { id: '4', name: '张依依4', type: '洗车机', money: 50, time: '2022-08-02' },
        // { id: '5', name: '张依依5', type: '洗车机', money: 50, time: '2022-08-02' },
        // { id: '6', name: '张依依6', type: '洗车机', money: 50, time: '2022-08-02' },
        // { id: '7', name: '张依依7', type: '洗车机', money: 50, time: '2022-08-02' },
        // { id: '8', name: '张依依8', type: '洗车机', money: 50, time: '2022-08-02' },
        // { id: '9', name: '张依依9', type: '洗车机', money: 50, time: '2022-08-02' },
        // { id: '10', name: '张依依10', type: '洗车机', money: 50, time: '2022-08-02' },
      ],
      mapData: [
        {lat: 39.88375, lng: 116.27488, styleId: 't1'},
        {lat: 39.89575, lng: 116.28988, styleId: 't2'},
        {lat: 39.97653, lng: 116.46142, styleId: 't3'},
        {lat: 39.98653, lng: 116.47142, styleId: 't4'},
        {lat: 40.00435, lng: 116.26792, styleId: 't5'},
        {lat: 40.02635, lng: 116.26992, styleId: 't6'},
        {lat: 39.81983, lng: 116.31502, styleId: 't7'},
        {lat: 39.83183, lng: 116.35402, styleId: 't8'},
        {lat: 39.83283, lng: 116.31502, styleId: 't9'},
      ],
      //地图坐标 测试数据
      mapDataTest: [
        {lat: 39.88375, lng: 116.27488, styleId: 'inspect'},
        {lat: 39.89575, lng: 116.28988, styleId: 'inspect'},
        {lat: 39.97653, lng: 116.46142, styleId: 'construction'},
        {lat: 39.98653, lng: 116.47142, styleId: 'construction'},
        {lat: 40.00435, lng: 116.26792, styleId: 'other'},
        {lat: 40.02635, lng: 116.26992, styleId: 'other'},
        {lat: 39.81983, lng: 116.31502, styleId: 'accident'},
        {lat: 39.83183, lng: 116.31402, styleId: 'accident'},
      ],
      option: {
        xAxis: {
          type: "category",

          data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
        },

        yAxis: {
          type: "value",
        },

        series: [
          {
            data: [150, 230, 224, 218, 135, 147, 260],

            type: "line",
          },
        ],
      },


      //圆
      option3: {
        title: {
          show: true,
          text: 60 + "%",
          x: "center",
          y: "center", // 通过x,y将标题(进度)定位在圆环中心
          // backgroundColor:'red',
          textStyle: {
            fontSize: "18",
            color: "#2BB6D5",
            fontWeight: "400",
            fontFamily: "DINPro, DINPro-Regular",
          },
        },
        tooltip: {
          trigger: "item",
          formatter: "{d}%",
          show: false,
        },
        legend: {
          orient: "vertical",
          x: "left",
          show: false,
        },

        series: [
          {
            color: ["#ffffff"],
            type: "pie",
            radius: "80%",
            center: ["50%", "50%"],
            data: [{value: 100, name: ""}],
            emphasis: {scale: false},
            label: {show: false},
          },
          {
            type: "pie",
            radius: ["80%", "95%"],
            center: ["50%", "50%"],
            avoidLabelOverlap: false,

            data: [
              {
                value: 60,
                name: "",
                itemStyle: {
                  color: "#2AB296",
                },
              },
              {
                value: 100 - 60,
                name: "",
                itemStyle: {
                  color: "#e6ebf2",
                  // color: "transparent", //透明色，也可以设置把其他颜色
                },
              },
            ],

            emphasis: {scale: false},
            label: {show: false},
          },
        ],

      },

      //设备数量
      option4: {
        barWidth: 10,
        tooltip: {},
        grid: {
          x: 70,
          y: 20,
          x2: 50,
          y2: 40, //距离下边的距离
        },

        color: ['#118975', '#1D56EF'],
        dataZoom: [
          {
            start: 0,//默认为0
            end: 100,//默认为100
            type: 'slider',
            //  maxValueSpan:9,//显示数据的条数(默认显示10个)
            show: false,
            yAxisIndex: [0],
            handleSize: 4,//滑动条的 左右2个滑动条的大小
            height: '60%',//组件高度
            left: 600, //左边的距离
            right: 8,//右边的距离
            top: 50,//上边边的距离
            borderColor: 'rgba(43,48,67,0.8)',
            fillerColor: '#1a45b9',//滑动块的颜色
            backgroundColor: 'rgba(13,33,117,0.5)',//两边未选中的滑动条区域的颜色
            showDataShadow: false,//是否显示数据阴影 默认auto
            showDetail: false,//即拖拽时候是否显示详细数值信息 默认true
            realtime: true, //是否实时更新
            filterMode: 'filter',
            yAxisIndex: [0, 1],//控制的y轴
          },
          //滑块的属性
          {
            type: 'inside',
            show: true,
            yAxisIndex: [0, 1],
            start: 1,//默认为1
            end: 4,//默认为100
          },
        ],

        // legend: {
        //     data:['销量']
        // },
        yAxis: {
          // splitLine:{show:false},
          type: "category",
          axisTick: {
            show: false, //坐标轴刻度线
          },
          axisLine: {
            show: true,
            onZero: false,
            onZeroAxisIndex: 1,
            lineStyle: {
              color: "#ffffff",
              width: 1
            },
            //轴线
            // show: false,
          },
          offset: 1,
          data: [],//"广告机","共享充电", "电机监控", "量子仪器","自动售货机",//"钢琴", "量子仪","陪护床","洗车机"
        },
        xAxis: {
          type: "value",
          splitLine: {show: false},
          axisLabel: {
            formatter: "{value}",
            color: "#ffffff",
            //坐标轴样式
            textStyle: {
              color: "#ffffff",
            },
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#ffffff",
            },
            //轴线
            // show: false,
          },
          axisTick: {
            show: false, //坐标轴刻度线
          },
        },
        series: [
          {
            type: "bar",
            data: [],//210, 380, 700, 410,210, 380, 700, 410, 410
          },
          {
            type: "bar",
            data: [],//360, 480, 800, 510,360, 480, 800, 510, 510
          },
        ],
      },

      //分布信息
      option10: {
        barWidth: 10,
        tooltip: {},
        grid: {
          x: 70,
          y: 20,
          x2: 50,
          y2: 40, //距离下边的距离
        },

        color: ['#118975', '#1D56EF'],
        dataZoom: [
          {
            start: 0,//默认为0
            end: 100,//默认为100
            type: 'slider',
            //maxValueSpan:6,//显示数据的条数(默认显示10个)
            show: false,
            yAxisIndex: [0],
            handleSize: 0,//滑动条的 左右2个滑动条的大小
            height: '60%',//组件高度
            left: 600, //左边的距离
            right: 8,//右边的距离
            top: 50,//上边边的距离
            borderColor: 'rgba(43,48,67,0.8)',
            fillerColor: '#1a45b9',//滑动块的颜色
            backgroundColor: 'rgba(13,33,117,0.5)',//两边未选中的滑动条区域的颜色
            showDataShadow: false,//是否显示数据阴影 默认auto
            showDetail: false,//即拖拽时候是否显示详细数值信息 默认true
            realtime: true, //是否实时更新
            filterMode: 'filter',
            yAxisIndex: [0, 1],//控制的y轴
          },
          //滑块的属性
          {
            type: 'inside',
            show: true,
            yAxisIndex: [0, 1],
            start: 1,//默认为1
            end: 2,//默认为100
          },
        ],

        // legend: {
        //     data:['销量']
        // },
        yAxis: {
          // splitLine:{show:false},
          type: "category",
          axisTick: {
            show: false, //坐标轴刻度线
          },
          axisLine: {
            show: true,
            onZero: false,
            onZeroAxisIndex: 1,
            lineStyle: {
              color: "#ffffff",
            },
            //轴线
            // show: false,
          },
          offset: 1,
          data: [],//"北京", "石家庄", "呼和浩特", "长春","上海", "杭州", "福州", "济南","武汉","广州","海口","成都","昆明","西安","西宁","乌鲁木齐","澳门"//'深圳'
        },
        xAxis: {
          type: "value",
          splitLine: {show: false},
          axisLabel: {
            formatter: "{value}",
            color: "#ffffff",
            //坐标轴样式
            textStyle: {
              color: "#ffffff",
            },
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#ffffff",
            },
            //轴线
            // show: false,
          },
          axisTick: {
            show: false, //坐标轴刻度线
          },
        },
        series: [
          {
            type: "bar",
            data: [],//210, 380, 700, 410,210, 380, 700, 410, 410,210,210, 380, 700, 410,210, 380, 700,
          },
          {
            type: "bar",
            data: [],//360, 480, 800, 510,360, 480, 800, 510, 510,360,360, 480, 800, 510,360, 480, 800,
          },
        ],
      },

      //门店数据  #35dca6  #35dca6
      option5: {
        barWidth: 15,
        tooltip: {},
        grid: {
          x: 40,
          y: 20,
          x2: 50,
          y2: 60, //距离下边的距离
        },
        // legend: {
        //     data:['销量']
        // },
        xAxis: {
          // splitLine:{show:false},
          type: "category",
          axisTick: {
            show: false, //坐标轴刻度线
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#ffffff",
            },
            //轴线
            // show: false,
          },
          // boundaryGap: false,
          // boundaryGap: [0,-10],
          data: ["8-1", "8-2", "8-3", "8-4", "8-5", "8-6", "8-7"],
        },
        yAxis: {
          type: "value",
          // boundaryGap:true,
          // scale: true,
          splitLine: {show: false},
          axisLabel: {
            formatter: "{value}",
            color: "#ffffff",
            //坐标轴样式
            textStyle: {
              color: "#ffffff",
            },
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#ffffff",
            },
            //轴线
            // show: false,
          },
          axisTick: {
            show: false, //坐标轴刻度线
          },
        },
        series: [
          {
            // name: "销量",
            type: "line",
            data: [5, 20, 36, 10, 10, 20, 30],
            color: "#35dca6",
            // itemStyle: {
            // color:'#35DCA6',
            // color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            //   {
            //     offset: 0,
            //     // color: '#248ff7'
            //     color: "#23C2E4",
            //   },
            //   {
            //     offset: 1,
            //     // color: 'rgba(22,75,247,0.1)'
            //     // color: '#0D3F99'
            //     color: "rgba(13,63,153,0)",
            //   },
            // ]),
            // },

            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {offset: 0, color: "#248f99"},
                  // { offset: 0.5, color: "pink" },
                  {offset: 1, color: "#0f4290"},
                ]),
              },
            }, //填充区域样式
            // lineStyle: {
            //   color: "#00b5ff",
            //   opacity: 1
            // },//线条的样式
            // itemStyle: {
            //   color: "rgb(255, 70, 131)",
            //   opacity: 0 //为0不会绘制图形拐点消失
            // } //拐点的样式
          },

          // },
        ],
      },

      //订单数据
      option6: {
        barWidth: 10,
        tooltip: {},
        grid: {
          x: 40,
          y: 10,
          x2: 50,
          y2: 40, //距离下边的距离
        },
        // legend: {
        //     data:['销量']
        // },
        xAxis: {
          // splitLine:{show:false},
          type: "category",
          axisTick: {
            show: false, //坐标轴刻度线
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#ffffff",
            },
            //轴线
            // show: false,
          },
          // boundaryGap: false,
          //"9-1", "9-2", "9-3", "9-4", "9-5", "9-6", "9-7"
          data: [],
        },
        yAxis: {
          type: "value",
          // scale: true,
          splitLine: {show: false},
          axisLabel: {
            formatter: "{value}",
            color: "#ffffff",
            //坐标轴样式
            textStyle: {
              color: "#ffffff",
            },
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#ffffff",
            },
            //轴线
            // show: false,
          },
          axisTick: {
            show: false, //坐标轴刻度线
          },
        },
        series: [
          {
            type: "line",
            data: [],//1000, 2000, 260, 1900, 3200, 4800, 6000
            color: "#FCBF4D",
          },
          // {
          //   type: "line",
          //   data: [1500, 1000, 3300, 4400, 2200, 2600, 5000],
          //   color: "#2FD174",
          // },
          // {
          //   type: "line",
          //   data: [2000, 2300, 4100, 3000, 3200, 3600, 4000],
          //   color: "#FFFFFF",
          // },
        ],
      },

      //底部 设备占
      option8: {
        // title: {
        //   text: 'Referer of a Website',
        //   subtext: 'Fake Data',
        //   left: 'center'
        // },
        // tooltip: {
        //   trigger: 'item'
        // },
        legend: {
          orient: "vertical",
          top: "34%",
          left: "33%",
          // left: 'right',
          data: [
            {
              icon: "circle",
              id: "1",
              name: "正常运行设备8000台",
              // textStyle: { color: "#ffffff", fontSize: "14px" },
              textStyle: {color: "#000", fontSize: "14px"},
            },
            {
              icon: "circle",
              id: "2",
              name: "异常设备200台",
              // textStyle: { color: "#ffffff", fontSize: "14px" },
              textStyle: {color: "#000", fontSize: "14px"},
            },
          ],
        },
        color: ["#e67777", "#34e1be"],

        series: [
          {
            // name: 'Access From',
            type: "pie",
            center: ["15%", "50%"],
            radius: ["0%", "80%"],
            label: {
              normal: {
                show: true,
                position: "inner",
                // position:'right',
                formatter: "{c} %",
                textStyle: {
                  color: "#ffffff",
                  // color:'red',
                  fontSize: "14px",
                },
              },
            },
            labelLine: {show: false},
            // silent:true, //去掉鼠标经过放大效果
            data: [
              {
                value: 25,
                name: "正常运行设备8000台",
              },
              {
                value: 75,
                name: "异常设备200台",
                // labelLine:{show:false},
              },
              // labelLine:{
              //   show:fale,
              // },
            ],
            // emphasis: {
            //   label:false,
            //   itemStyle: {
            //     shadowBlur: 10,
            //     shadowOffsetX: 0,
            //     shadowColor: 'rgba(0, 0, 0, 0.5)'
            //   }
            // }


          },
        ],
      },

      clickIndex: -1, //当前点击的图标
      clickFlag: true,//点击标记 是否点击自身

      img_1: require('@/assets/image/home/t-1.png'),
      img_2: require('@/assets/image/home/t-2.png'),
      img_3: require('@/assets/image/home/t-3.png'),
      img_4: require('@/assets/image/home/t-4.png'),
      img_5: require('@/assets/image/home/t-5.png'),
      img_6: require('@/assets/image/home/t-6.png'),
      img_7: require('@/assets/image/home/t-7.png'),
      img_8: require('@/assets/image/home/t-8.png'),
      img_9: require('@/assets/image/home/t-9.png'),
      typeImgList: {
        img_1: require('@/assets/image/home/t-1.png'),
        img_2: require('@/assets/image/home/t-2.png'),
        img_3: require('@/assets/image/home/t-3.png'),
        img_4: require('@/assets/image/home/t-4.png'),
        img_5: require('@/assets/image/home/t-5.png'),
        img_6: require('@/assets/image/home/t-6.png'),
        img_7: require('@/assets/image/home/t-7.png'),
        img_8: require('@/assets/image/home/t-8.png'),
        img_9: require('@/assets/image/home/t-9.png'),

        img_h_1: require('@/assets/image/home/t-h-1.png'),
        img_h_2: require('@/assets/image/home/t-h-2.png'),
        img_h_3: require('@/assets/image/home/t-h-3.png'),
        img_h_4: require('@/assets/image/home/t-h-4.png'),
        img_h_5: require('@/assets/image/home/t-h-5.png'),
        img_h_6: require('@/assets/image/home/t-h-6.png'),
        img_h_7: require('@/assets/image/home/t-h-7.png'),
        img_h_8: require('@/assets/image/home/t-h-8.png'),
        img_h_9: require('@/assets/image/home/t-h-9.png'),

        img_white_1: require('@/assets/image/home/t-white-1.png'),
        img_white_2: require('@/assets/image/home/t-white-2.png'),
        img_white_3: require('@/assets/image/home/t-white-3.png'),
        img_white_4: require('@/assets/image/home/t-white-4.png'),
        img_white_5: require('@/assets/image/home/t-white-5.png'),
        img_white_6: require('@/assets/image/home/t-white-6.png'),
        img_white_7: require('@/assets/image/home/t-white-7.png'),
        img_white_8: require('@/assets/image/home/t-white-8.png'),
        img_white_9: require('@/assets/image/home/t-white-9.png'),

        img_black_1: require('@/assets/image/home/t-black-1.png'),
        img_black_2: require('@/assets/image/home/t-black-2.png'),
        img_black_3: require('@/assets/image/home/t-black-3.png'),
        img_black_4: require('@/assets/image/home/t-black-4.png'),
        img_black_5: require('@/assets/image/home/t-black-5.png'),
        img_black_6: require('@/assets/image/home/t-black-6.png'),
        img_black_7: require('@/assets/image/home/t-black-7.png'),
        img_black_8: require('@/assets/image/home/t-black-8.png'),
        img_black_9: require('@/assets/image/home/t-black-9.png'),
      },
      zoom: 12,
      timer: null,
      checkName: '',
      lenghei: 10
    };
  },
  components: {
    vueSeamlessScroll,
  },
  created() {
    this.newData = new Date().toISOString().slice(0, 10);
    const week = this.getWeekDate();
    this.week = week;
    //new DevicePixelRatio().init();
    this.getInitData();
    this.timer = setInterval(() => {
      this.getInitData();
    }, 1000 * 60)
  },
  destroyed() {
    clearInterval(this.timer)
  },
  mounted() {

    //初始化天地图
    this.initMapWhenReady();

    //订单数据
    const orderDataChart = echarts.init(document.querySelector("#order-trend"));
    orderDataChart.setOption(this.option6);

    //设备数量
    const equipmentChart = echarts.init(document.querySelector("#equipment"));
    equipmentChart.setOption(this.option4);

    //设备数量
    const regionChart = echarts.init(document.querySelector("#region"));
    regionChart.setOption(this.option10);
    window.addEventListener('wheel', this.handleMouseWheel, {
      passive: false,
    })

    //平台注册用户
    // const myChart = echarts.init(document.querySelector("#test"));
    // myChart.setOption(this.option3);

    // const test2 = echarts.init(document.querySelector("#test2"));
    // test2.setOption(this.option3);

    // const test3 = echarts.init(document.querySelector("#test3"));
    // test3.setOption(this.option3);

    // const test4 = echarts.init(document.querySelector("#test4"));
    // test4.setOption(this.option3);

    // //门店数量
    // const storeChart = echarts.init(document.querySelector("#store"));
    // storeChart.setOption(this.option5);

    //底部 设备占比
    // const option8 = echarts.init(document.querySelector("#equipment-ratio"));
    // option8.setOption(this.option8);

  },
  beforeDestroy() {
    window.removeEventListener('wheel', this.handleMouseWheel, {
      passive: false,
    })
  },
  methods: {
    zoomEnd(e) {
      if (this.map) {
        this.zoom = this.map.getZoom();
      }
      this.lenghei = 2 * this.zoom;
      this.$forceUpdate();
    },
    scaleMin() {
      let lv = this.zoom;
      lv--;
      if (lv < 1) lv = 1;
      this.zoom = Number(lv);
      if (this.map) this.map.setZoom(lv);
    },
    scaleMax() {
      let lv = this.zoom;
      lv++;
      if (lv > 18) lv = 18;
      this.zoom = Number(lv);
      if (this.map) this.map.setZoom(lv);
    },
    handleMouseWheel(e) {
    },
    // 获取当前位置（浏览器GPS定位）
    getCurrentPosition() {
      let that = this;
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          function (position) {
            const lng = position.coords.longitude;
            const lat = position.coords.latitude;
            that.lng = lng;
            that.lat = lat;
            that.currentLocation = [lng, lat];
            console.log('浏览器GPS定位成功', lng, lat);
            if (that.map) {
              that.map.centerAndZoom(new T.LngLat(lng, lat), that.zoom);
            }
            // 通过天地图逆地理编码获取城市名
            that.$axios.get(
              `https://api.tianditu.gov.cn/geocoder?postStr={'lon':${lng},'lat':${lat},'ver':1}&type=geocode&tk=eb55ffd335635d032454b3a54ac95d88`
            ).then(res => {
              if (res.data && res.data.result) {
                const addr = res.data.result;
                that.city = addr.formatted_address || (addr.addressComponent ? addr.addressComponent.province + addr.addressComponent.city : '');
              }
            }).catch(() => { that.city = that.city || '广东省深圳市'; });
          },
          function (error) {
            console.log('浏览器GPS定位失败，使用默认位置', error);
            that.city = '广东省深圳市';
            that.currentLocation = [that.lng, that.lat];
          },
          { timeout: 10000, enableHighAccuracy: false }
        );
      } else {
        console.log('浏览器不支持定位');
        that.city = '广东省深圳市';
        that.currentLocation = [that.lng, that.lat];
      }
    },
    async getInitData() {
      //会员信息
      this.$axios.get('https://shuju.mmwl.vip/api/mmwl/boot/member_info').then((res) => {
        if (res.data.code == 200) {
          this.member_info = res.data.data;
        }
      })
      this.$axios.get('https://shuju.mmwl.vip/api/mmwl/boot/equipment/category/list').then((res) => {
        if (res.data.code == 200) {
          this.datanrec = res.data.data;
        }
      })

      //设备信息
      this.$axios.get('https://shuju.mmwl.vip/api/mmwl/boot/device_info').then((res) => {
        if (res.data.code == 200) {
          this.device_list = res.data.data;
          //option4
          let dataList = [];
          let dataList2 = [];
          let device_Data_name = [];
          if (res.data.data.device_list.length > 0) {
            res.data.data.device_list.filter((item) => {
              if (item.device_type == '钢琴') {
                item.device_type = "钢琴琴"
              }
              device_Data_name.push(item.device_type)
              dataList.push(item.total)
              dataList2.push(item.run)
            })
          }
          console.log(res.data.data)
          console.log(dataList)
          console.log(dataList2)
          // console.log(device_Data_name)
          // console.log(dataList)
          // console.log(dataList2)
          // this.option4.yAxis.data=device_Data_name;
          // this.option4.series[0].data=dataList;
          // this.option4.series[1].data=dataList2;
          //
          // const equipmentChart = echarts.init(document.querySelector("#equipment"));
          // equipmentChart.setOption(this.option4);
          var chartDom = document.getElementById('equipment');
          var myChart = echarts.init(chartDom);
          var option;

          option = {
            xAxis: {
              type: 'category',
              data: device_Data_name,
              minInterval: 1,
              axisLine: {
                lineStyle: {
                  color: "#fff",
                }
              },
              axisTick: {
                show: false, //坐标轴刻度线
              },
              axisLabel: {
                interval: 0,//横轴信息全部显示
                rotate: -30,// -20度角倾斜显示
              }
            },
            dataZoom: [{
              type: 'slider',
              xAxisIndex: [0],
              start: 10,
              end: 30
            },
            ],
            yAxis: {
              type: 'value',
              minInterval: 1,
              splitLine: {
                show: false
              },
              // y 轴线
              axisLine: {
                show: true,
                lineStyle: {
                  color: "#fff",
                }
              },
            },
            series: [
              {
                data: dataList,
                type: 'bar',
              },
              {
                data: dataList2,
                type: 'bar',
              }
            ]
          };

          option && myChart.setOption(option);
        }
      })

      //设备分布信息
      this.$axios.get('https://shuju.mmwl.vip/api/mmwl/boot/city_device_info').then((res) => {
        if (res.data.code == 200) {
          this.city_device_info = res.data.data;
          //option10
          let dataList = [];
          let dataList2 = [];
          let city_Data_name = [];
          if (res.data.data.city_list.length > 0) {
            res.data.data.city_list.filter((item) => {
              city_Data_name.push(item.city)
              dataList.push(item.total)
              dataList2.push(item.run)
            })
          }
          console.log(res.data.data)
          console.log(dataList)
          console.log(dataList2)
          // this.option10.yAxis.data=city_Data_name;
          // this.option10.series[0].data=dataList;
          // this.option10.series[1].data=dataList2;
          //
          // //设备数量
          // const regionChart = echarts.init(document.querySelector("#region"));
          // regionChart.setOption(this.option10);
          var chartDom = document.getElementById('region');
          var myChart = echarts.init(chartDom);
          var option;

          option = {
            xAxis: {
              type: 'category',
              data: city_Data_name,
              axisLine: {
                lineStyle: {
                  color: "#fff",
                }
              },
              axisTick: {
                show: false, //坐标轴刻度线
              },
              axisLabel: {
                interval: 0,//横轴信息全部显示
                rotate: -30,// -20度角倾斜显示
              }
            },
            yAxis: {
              type: 'value',
              minInterval: 1,
              splitLine: {
                show: false
              },
              // y 轴线
              axisLine: {
                show: true,
                lineStyle: {
                  color: "#fff",
                }
              },

            },
            series: [
              {
                data: dataList,
                type: 'bar',
              },

            ]
          };

          option && myChart.setOption(option);
        }
      })

      //营业信息
      this.$axios.get('https://shuju.mmwl.vip/api/mmwl/boot/order_info').then((res) => {
        if (res.data.code == 200) {
          this.order_info = res.data.data;
        }
      })

      //订单列表
      this.$axios.get('https://shuju.mmwl.vip/api/mmwl/boot/order_list').then((res) => {
        if (res.data.code == 200) {
          this.orderInfoList = res.data.data;
          this.orderInfoList.filter((item) => {
            item.name = item.name.substr(0, 6)
          });
        }
      })

      // 订单趋势
      this.$axios.get('https://shuju.mmwl.vip/api/mmwl/boot/order_trend').then((res) => {
        if (res.data.code == 200) {
          let array = [];
          let array2 = []
          if (res.data.data.length > 0) {
            res.data.data.filter((item) => {
              array.push(item.name)
              array2.push(item.money)
            })
          }
          this.option6.xAxis.data = array;
          this.option6.series[0].data = array2;

          const orderDataChart = echarts.init(document.querySelector("#order-trend"));
          orderDataChart.setOption(this.option6);
        }
      })
      setTimeout(() => {
        this.getDevice()
      }, 1000);


      /*
      this.$axios.get('http://shuju.mmwl.vip/').then((res) => {
          if(res.status==200){
            this.orderInfoList=res.data.order_list;
            this.member_info=res.data.member_info;
            this.device_list=res.data.device_info;
            this.city_device_info=res.data.city_device_info;
            this.order_info=res.data.order_info;

            if(res.data.order_trend.length>0){
                let array=[];
                let array2=[]
                res.data.order_trend.filter((item)=>{
                  array.push(item.name)
                  array2.push(item.money)
                })
                this.option6.xAxis.data=array;
                this.option6.series[0].data=array2;
            }

            if(res.data.order_trend.length>0){
                let array=[];
                let array2=[]
                res.data.order_trend.filter((item)=>{
                  array.push(item.name)
                  array2.push(item.money)
                })
                this.option6.xAxis.data=array;
                this.option6.series[0].data=array2;
            }
            //option4
            let dataList=[];
            let dataList2=[];
            dataList.push(res.data.device_info.device_list.piano.total)
            dataList.push(res.data.device_info.device_list.quantum_meter.total)
            dataList.push(res.data.device_info.device_list.bed.total)
            dataList.push(res.data.device_info.device_list.car_washer.total)

            dataList2.push(res.data.device_info.device_list.piano.run)
            dataList2.push(res.data.device_info.device_list.quantum_meter.run)
            dataList2.push(res.data.device_info.device_list.bed.run)
            dataList2.push(res.data.device_info.device_list.car_washer.run)


            //this.option4.series[0].data=array2;
            this.option4.series[0].data=dataList;
            this.option4.series[1].data=dataList2;

            let dataList3=[];
            let dataList4=[];
            dataList3.push(res.data.city_device_info.city_list.sz.total)
            dataList4.push(res.data.city_device_info.city_list.sz.run)
            this.option10.series[0].data=dataList3;
            this.option10.series[1].data=dataList4;

            const equipmentChart = echarts.init(document.querySelector("#equipment"));
            equipmentChart.setOption(this.option4);

            const orderDataChart = echarts.init(document.querySelector("#order-trend"));
            orderDataChart.setOption(this.option6);

            //设备数量
            const regionChart = echarts.init(document.querySelector("#region"));
            regionChart.setOption(this.option10);

          }
      })
       */
    },
    getDevice(name = '') {
      // 设备分布地址
      this.$axios.get('https://shuju.mmwl.vip/api/mmwl/boot/device_place_list').then((res) => {
        if (res.data.code == 200) {
          //this.orderInfoList=res.data.data;
          console.log(res.data.data)
          if (res.data.data.length > 0) {
            res.data.data.filter((item) => {
              if (item.device_type == '共享钢琴') {
                item.typeId = 1;
              } else if (item.device_type == '跑步机') {
                item.typeId = 2;
              } else if (item.device_type == '广告机') {
                item.typeId = 3;
              } else if (item.device_type == '陪护床') {
                item.typeId = 4;
              } else if (item.device_type == '到店洗车' || item.device_type == '上门洗车') {
                item.typeId = 5;
              } else if (item.device_type == '共享充电') {
                item.typeId = 6;
              } else if (item.device_type == '电机监控') {
                item.typeId = 7;
              } else if (item.device_type.indexOf('量子') != -1 || item.device_type == '理疗康养') {
                item.typeId = 8;
              } else if (item.device_type == '自动售货机') {
                item.typeId = 9;
              }
            });
          }
          this.points = res.data.data
          console.log(this.points, '-----------');
          this.renderMarkers();
        }
      })

    },
    // 这个方法是获取 今天往后七天的日期和星期(往前几天的话减号就行了)
    getWeekDate() {
      var weeks = new Array("星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六");
      var now = new Date();
      var day = now.getDay();
      var week = weeks[day];
      return week;
    },
    //鼠标移入
    overHandle(type, name) {
      if (this.clickIndex != type) {
        this['img_' + type] = this.typeImgList['img_h_' + type]
        this.index = type
      }
    },
    //鼠标移出
    leaveHandle(type) {
      if (this.clickIndex != type) {
        this['img_' + type] = this.typeImgList['img_' + type]
        this.index = 0
      }
      //this.getDevice()
    },
    change() {
      this.skinStatus = !this.skinStatus;
      if (this.skinStatus) {
        document.head.querySelector('#skin').setAttribute('href', "../../static/css/white.css")
        localStorage.setItem("style", "../../static/css/white.css");
        if (this.map) this.map.setMapType(T.MapType.NORMAL);
      } else {
        document.head.querySelector('#skin').setAttribute('href', "../../static/css/black.css")
        localStorage.setItem("style", "../../static/css/black.css");
        if (this.map) this.map.setMapType(T.MapType.SATELLITE);
      }
      this.changeMapMark();
    },
    // 修改地图标记图片（重新渲染所有标注）
    changeMapMark() {
      this.renderMarkers();
    },
    //关闭菜单
    closeMenu() {
      this.isShow = false;
      this.showArrowStatus = false;
      this.hideArrowStatus = true;
    },
    //打开菜单
    openMenu() {
      this.isShow = true;
      this.showArrowStatus = false;
      this.hideArrowStatus = false;
    },
    //移入
    menuOver() {
      this.showArrowStatus = true;
    },
    //移出
    menuLeave() {
      this.showArrowStatus = false;
    },

    //全屏
    screen() {
      this.isShow = !this.isShow;
      this.fullscreen = !this.fullscreen;

      // if (!screenfull.isEnabled) {
      //   this.$message("您的浏览器不能全屏");
      //   return false;
      // }
      // this.fullscreen = !this.fullscreen;
      // screenfull.toggle();
    },
    //点击分类图标
    typeClick(id, index) {
      // 设备分布地址
      this.$axios.get('https://shuju.mmwl.vip/api/mmwl/boot/device_place_list?categoryId=' + id).then((res) => {
        if (res.data.code == 200) {
          //this.orderInfoList=res.data.data;
          this.clickIndex = index
          if (res.data.data.length > 0) {
            res.data.data.map((item) => {
              if (item.device_type == '共享钢琴') {
                item.typeId = 1;
              } else if (item.device_type == '跑步机') {
                item.typeId = 2;
              } else if (item.device_type == '广告机') {
                item.typeId = 3;
              } else if (item.device_type == '陪护床') {
                item.typeId = 4;
              } else if (item.device_type == '到店洗车' || item.device_type == '上门洗车') {
                item.typeId = 5;
              } else if (item.device_type == '共享充电') {
                item.typeId = 6;
              } else if (item.device_type == '电机监控') {
                item.typeId = 7;
              } else if (item.device_type.indexOf('量子') != -1 || item.device_type == '理疗康养') {
                item.typeId = 8;
              } else if (item.device_type == '自动售货机') {
                item.typeId = 9;
              }
            });
            console.log(res.data.data)
          }
          this.points = res.data.data
          this.renderMarkers();
        }
      })
    },
    dragend() {
      // 天地图标注不原生支持拖拽，保留方法占位
    },
    dragstart() {
      // 天地图标注不原生支持拖拽，保留方法占位
    },
    // 设备标注点击
    lookDetail(item) {
      console.log('设备详情', item);
      // 可在此处打开弹窗或跳转详情页
    },

    // ========== 天地图核心方法 ==========

    // 等待天地图API加载完成后初始化
    initMapWhenReady() {
      if (window.T) {
        this.initTMap();
      } else {
        setTimeout(() => this.initMapWhenReady(), 200);
      }
    },

    // 初始化天地图
    initTMap() {
      var that = this;
      setTimeout(function () {
        var container = document.getElementById('tdtMap');
        if (!container || container.offsetWidth === 0 || container.offsetHeight === 0) {
          console.warn('天地图容器尺寸为0，延迟重试...');
          setTimeout(function () { that.initTMap(); }, 300);
          return;
        }
        console.log('天地图容器尺寸:', container.offsetWidth, 'x', container.offsetHeight);

        try {
          // 创建地图，显式添加矢量瓦片图层（备用方案）
          var map = new T.Map('tdtMap');
          map.centerAndZoom(new T.LngLat(that.lng, that.lat), that.zoom);
          map.enableScrollWheelZoom();
          map.addEventListener('zoomend', that.zoomEnd);

          // 显式添加天地图矢量图层
          var vecLayer = new T.TileLayer(
            'https://t0.tianditu.gov.cn/vec_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=vec&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=eb55ffd335635d032454b3a54ac95d88',
            { minZoom: 1, maxZoom: 18 }
          );
          map.addLayer(vecLayer);

          // 添加注记图层
          var cvaLayer = new T.TileLayer(
            'https://t0.tianditu.gov.cn/cva_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=cva&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=eb55ffd335635d032454b3a54ac95d88',
            { minZoom: 1, maxZoom: 18 }
          );
          map.addLayer(cvaLayer);

          // 添加缩放控件
          var zoomControl = new T.Control.Zoom();
          map.addControl(zoomControl);

          that.map = map;
          that.vecLayer = vecLayer;
          that.cvaLayer = cvaLayer;
          console.log('天地图初始化成功');

          // 瓦片加载检测：3秒后检查是否有瓦片请求失败
          setTimeout(function () {
            that.checkTileLoad();
          }, 3000);

          // 获取当前位置
          that.getCurrentPosition();

          // 延迟渲染标注
          setTimeout(function () {
            if (that.points.length > 0) {
              that.renderMarkers();
            }
          }, 1500);
        } catch (e) {
          console.error('天地图初始化失败:', e);
          alert('天地图初始化失败: ' + e.message);
        }
      }, 100);
    },

    // 检测瓦片是否加载成功
    checkTileLoad() {
      var container = document.getElementById('tdtMap');
      if (!container) return;
      var imgs = container.querySelectorAll('img');
      var failCount = 0;
      imgs.forEach(function (img) {
        if (!img.complete || img.naturalWidth === 0) {
          failCount++;
        }
      });
      if (failCount > 0) {
        console.warn('瓦片加载失败数量:', failCount, '请检查天地图密钥白名单配置');
        // this.tdtLoadError = true;
      }
    },

    // 重试加载地图
    retryLoadMap() {
      this.tdtLoadError = false;
      if (this.map) {
        this.map.clearOverLays();
        this.map = null;
      }
      document.getElementById('tdtMap').innerHTML = '';
      this.initMapWhenReady();
    },

    // 清除所有标注
    clearMarkers() {
      if (this.markerList && this.markerList.length > 0) {
        this.markerList.forEach(function (marker) {
          if (this.map) this.map.removeOverLay(marker);
        }.bind(this));
      }
      this.markerList = [];
    },

    // 渲染标注点
    renderMarkers() {
      if (!this.map) return;
      this.clearMarkers();
      var that = this;
      var t = that.skinStatus ? 'black' : 'white';
      var defaultIcon = that.typeImgList['img_' + t + '_1'];
      that.markerList = that.points.map(function (item) {
        var rawUrl = (item.typeId && that.typeImgList['img_' + t + '_' + item.typeId]) || defaultIcon;
        // 防御：webpack require 可能返回模块对象
        var iconUrl = (typeof rawUrl === 'object' && rawUrl !== null && rawUrl.default) ? rawUrl.default : rawUrl;
        console.log('设备类型:', item.device_type, 'typeId:', item.typeId, '图标URL:', iconUrl);

        var lnglat = new T.LngLat(item.longitude, item.latitude);
        var marker;
        if (iconUrl && typeof iconUrl === 'string') {
          var icon = new T.Icon({
            iconUrl: iconUrl,
            iconSize: new T.Point(30, 30),
            iconAnchor: new T.Point(15, 15)
          });
          marker = new T.Marker(lnglat, { icon: icon });
        } else {
          console.warn('图标URL无效，使用默认标注:', item);
          marker = new T.Marker(lnglat);
        }
        (function (deviceItem) {
          marker.addEventListener('click', function () {
            that.lookDetail(deviceItem);
          });
        })(item);
        that.map.addOverLay(marker);
        return marker;
      });
    },


  },
}
</script>

<!-- <style lang="less" scoped>
// .head {
//     position: absolute;
//     left: 0;
//     top: 0;
//     width: 100%;
//     height: 100px;
//     background: url("../assets/image/home/head.png") no-repeat;
//     background-size: 100% 100%;
//     overflow: hidden;
//     z-index: 2001;



//     // .head-title {
//     //   display: flex;
//     //   justify-content: center;
//     //   align-items: center;
//     //   flex: 1;
//     //   font-size: 30px;
//     //   color: #FFFFFF;
//     //   height: 100px;


//     //   .head-title-bg {
//     //     width: 464px;
//     //     height: 56px;
//     //     line-height: 56px;
//     //     text-align: center;
//     //     background: url("../assets/image/home/head-title.png") no-repeat;
//     //     background-size: 100% 100%;
//     //   }
//     // }

//     // .full-screen {
//     //   width: 543px;
//     //   margin-top: 33px;
//     //   margin-right: 33px;
//     //   // color: var(--theme-text-color);
//     //   color: #ffffff;
//     //   text-align: right;

//     //   .full-screen-title {
//     //     cursor: pointer;
//     //   }
//     // }
//   }
</style> -->


<style lang="less" scoped>
#tdtMap,
.bm-view {
  width: 100%;
  height: 100%;
  position: relative;
}

/* 隐藏天地图Logo和版权信息 */
#tdtMap .tdt-control-copyright,
#tdtMap .tdt-logo {
  display: none !important;
}

#tdt-error-banner {
  position: absolute;
  top: 120px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 99999;
  background: rgba(220, 20, 60, 0.9);
  color: #fff;
  padding: 12px 20px;
  border-radius: 6px;
  font-size: 14px;
  line-height: 1.6;
  text-align: center;
  box-shadow: 0 4px 12px rgba(0,0,0,0.3);
}
#tdt-error-banner a {
  color: #ffeb3b;
  text-decoration: underline;
}
#tdt-error-banner code {
  background: rgba(255,255,255,0.2);
  padding: 2px 6px;
  border-radius: 3px;
  font-family: monospace;
}
#tdt-error-banner button {
  margin-left: 10px;
  padding: 4px 12px;
  background: #fff;
  color: #c00;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: bold;
}

// .left-mg {
//   margin: 17px 3px 27px 14px;
// }

// .right-mg {
//   margin: 20px 14px 18px 4px;
// }

// ul {
//   list-style: none;
//   padding: 0;
//   margin: 0;
// }

// .order-list {
//   margin: 10px 34px 0 0;

//   li {
//     height: 52px;
//     line-height: 51px;
//     background: rgba(48, 190, 232, 0.3);

//     &:hover {
//       background-color: #165890;
//     }
//   }

//   .order-head {
//     border-left: 1px solid #00ffad;
//     border-top: 1px solid #00ffad;
//     border-right: 1px solid #00ffad;
//     border-bottom: 1px solid #2fbee8;
//     background-image: linear-gradient(#22738e, #226ca6);
//   }

//   .order-row {
//     display: flex;
//     align-content: center;

//     div {
//       flex: 1;
//       text-align: center;
//       color: #ffffff;
//       font-size: 16px;
//     }
//   }

//   .order-content {
//     border-left: 1px solid #2fbee8;
//     border-right: 1px solid #2fbee8;
//     border-bottom: 1px solid #2fbee8;
//   }
// }

.order-height {
  height: 96%;
}

#equipment {
  width: 100%;
  height: 250px;
}

#store {
  height: 250px;
  width: 100%;
}

#order-data {
  height: 250px;
  width: 100%;
}

.box-bg {
  background: url("../assets/image/home/box.png") no-repeat;
  background-size: 100% 100%;
  margin-top: -6px;
}

.order-frame {
  background: url("../assets/image/home/order-frame.png") no-repeat;
  background-size: 100% 100%;
}

.order-info {
  background: url("../assets/image/home/order-info.png") no-repeat;
  background-size: 100% 100%;
}

.right-mt {
  margin-top: -10px;
}


.type-img {
  vertical-align: middle;
  // height: 1.25rem;
  // width: 1.25rem;
  height: 20px;
  width: 20px;
}

/* 标准写法 */
:fullscreen {

  .box-wrap,
  .box-wrap-order {
    height: auto !important;
  }

  // .box-content,.order-height{
  //   height: 100%;
  // }
}
</style>


<!--  新版本样式  -->
<style lang="less" scoped>
.home {
  position: relative;
  height: 100vh;
  width: 100vw;
}

.head-wrap {
  width: 100%;
  height: 100px;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2001;
}

.head {
  display: flex;
  width: 100%;
  height: 100px;
  background: url("../assets/image/home/head3.png") no-repeat;
  background-size: 100% 100%;
  overflow: hidden;
  z-index: 2001;
}

.head-flag-img {
  width: 44px;
  height: 31px;
}

.head-title-text {
  font-size: 32px;
  margin-left: 11px;
  font-weight: normal;
  color: #FFFFFF;
  letter-spacing: 11px;
  font-family: MicrosoftYaHei-Bold-, MicrosoftYaHei-Bold;
}

.address-wrap {
  position: absolute;
  left: 0;
  top: 50%;
  display: flex;
  box-sizing: border-box;
  padding-left: 20px;
  transform: translateY(-10px);
}

.address-img {
  width: 16px;
  height: 20px;
}

.address-text {
  font-size: 16px;
  color: #FFFFFF;
  padding-left: 10px;
}

.time-wrap {
  position: absolute;
  top: 50%;
  right: 10px;
  display: flex;
  font-size: 16px;
  color: #FFFFFF;
  transform: translateY(-10px);
}

.head-title {
  display: flex;
  align-items: center;
  position: absolute;
  top: 50%;
  left: 51%;
  transform: translate(-50%, -56%);
}

.time {
  padding-right: 20px;
}

.screen {
  margin-left: 10px;
  color: #ffffff;
  cursor: pointer;
}

.left {
  position: absolute;
  left: 0;
  top: 100px;
  height: calc(100% - 100px);
  width: 26%;
  padding: 4px 0 10px 0;
  z-index: 2001;
}

.main {
  position: absolute;
  left: 28%;
  top: 92%;
  width: 100%;
  z-index: 2001;
}

.type-wrap {
  display: flex;
}

.type-item {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50px;
  height: 50px;
  line-height: 50px;
  // height: 42px;
  margin-right: 23px;
  background-color: #FFFFFF;
  border-radius: 50%;
  cursor: pointer;
}

.type-item-bg-img {
  width: 28px;
  height: 30px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.type-item-title {
  position: absolute;
  top: -35px;
  left: -5px;
  height: 30px;
  line-height: 30px;
  padding: 0 5px;
  font-size: 16px;
  text-align: center;
  // color: var(--changeColor);
  // color: #1D2693;
  background-color: var(--bgColor);
}

.type-item-img {
  // height: 100%;
  // width: 100%;
  cursor: pointer;
  width: 28px;
  height: 30px;
}

.type-item-title-1, .type-item-title-2, .type-item-title-3,
.type-item-title-4, .type-item-title-5, .type-item-title-6,
.type-item-title-7, .type-item-title-8, .type-item-title-9 {
  position: absolute;
  display: none;
  background-color: #ffffff;
  padding: 5px 20px;
  top: -30px;
  // color: var(--changeColor);
  color: #1D2693;
  font-size: 15px;
}

.type-item-title-1 {
  left: -8px;
}

.type-item-title-2 {
  left: 62px;
}

.type-item-title-3 {
  left: 136px;
}

.type-item-title-4 {
  left: 208px;
}

.type-item-title-5 {
  left: 280px;
}

.type-item-title-6 {
  left: 344px;
}

.type-item-title-7 {
  left: 422px;
}

.type-item-title-8 {
  left: 494px;
}

.type-item-title-9 {
  left: 560px;
}

.show {
  display: block !important;
}

.right {
  position: absolute;
  right: 0;
  top: 100px;
  height: calc(100% - 100px);
  width: 26%;
  padding: 4px 0 10px 0;
  z-index: 2001;
}

// .bg-color {
//   background-color: var(--bgColor);
// }

.map {
  height: 100%;
  width: 100%;
  overflow: hidden;
}


.change {
  position: absolute;
  left: 69.8%;
  top: 95%;
  z-index: 2002;
  color: var(--changeColor);
  font-size: 16px;
  cursor: pointer;
}

.change2 {
  position: absolute;
  left: 69.8%;
  top: 85%;
  z-index: 2002;
  color: var(--changeColor);
  font-size: 16px;
  cursor: pointer;
}

.box-content {
  height: 33%;
  box-sizing: border-box;
  margin-bottom: 4px;
  background-color: #1d2693;
  padding: 20px;
  overflow: hidden;
}

.box-title {
  font-size: 18px;
  color: #FFFFFF;
}

.box-list {
  height: 72%;
}

.box-list-item-wrap {
  display: flex;
}

.box-list-item {
  display: flex;
  margin-right: 30px;
}

.box-list-item-name {
  width: 100px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  background: #118975;
  border-radius: 4px;
  margin-right: 5px;
  font-size: 16px;
  color: #FFFFFF;
}

.box-list-item-number {
  box-sizing: border-box;
  width: 110px;
  height: 40px;
  line-height: 40px;
  background: #2156EF;
  font-size: 16px;
  color: #FFFFFF;
  padding: 0 10px;
}

.member-top {
  margin: 45px 0;
}

.box-title-wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.box-total-wrap {
  display: flex;
  font-size: 12px;
  color: #FFFFFF;
  background: #1A45B9;
  padding: 2px 5px 2px 12px;
}

.box-total-left {
  margin-right: 22px;
}

.business-item {
  margin-top: 40px;
  //display: flex;
  //justify-content: space-between;
  //margin-bottom: 40px;
  font-size: 14px;
  color: #FFFFFF;
}

.business-top {
  margin-top: 35px;
}

.order-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  height: 30px;
  background: #1A45B9;
  font-size: 12px;
  font-weight: 400;
  color: #FFFFFF;
  margin-top: 10px;
}

.order-head-item {
  flex: 1;
  text-align: center;
  color: #FFFFFF;
  font-size: 12px;
}

.order-list {
  height: 100%;
  overflow: hidden;
  background-color: #13368B;
}

.order-list-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  font-size: 12px;
  color: #FFFFFF;
  padding: 13px 30px 10px 30px;
  border-bottom: 1px solid #425EA2;
}

.order-list-row div {
  width: 20%;
  text-align: center;
}

.seamless-warp {
  min-height: 160px;
  overflow: hidden;
}

.box-total-recharge {
  margin: 0 30px;
}

.consume {
  color: #3DDE82;
}

.recharge {
  color: #FCBF4D;
}

.order {
  color: #FFFFFF;
}

.order-trend-wrap {
  width: 100%;
  height: 100%;
}

.box-graphical {
  width: 100%;
  height: 100%;
}

#order-trend {
  width: 100%;
  height: 100%;
}

#equipment {
  height: 100%;
  width: 100%;
}

#region {
  height: 100%;
  width: 100%;
}


.show-arrow-left {
  position: absolute;
  top: 48%;
  left: 100%;
  z-index: 2005;
  cursor: pointer;
}

.show-arrow-right {
  position: absolute;
  top: 48%;
  right: 100%;
  cursor: pointer;
  z-index: 2005;
}

.left-triangle-show {
  margin-left: 5px;
  width: 20px;
  height: 20px;
  border-top: 5px solid var(--changeColor);
  border-left: 5px solid var(--changeColor);
  transform: rotate(-45deg);
  cursor: pointer;
}

.right-triangle-show {
  margin-right: 5px;
  width: 20px;
  height: 20px;
  border-top: 5px solid var(--changeColor);
  border-left: 5px solid var(--changeColor);
  transform: rotate(135deg);
  cursor: pointer;
}

.left-triangle {
  margin-left: -10px;
  width: 20px;
  height: 20px;
  border-top: 5px solid var(--changeColor);
  border-left: 5px solid var(--changeColor);
  transform: rotate(135deg);
  cursor: pointer;
}

.right-triangle {
  margin-right: -10px;
  width: 20px;
  height: 20px;
  border-top: 5px solid var(--changeColor);
  border-left: 5px solid var(--changeColor);
  transform: rotate(-45deg);
  cursor: pointer;
}

.hide-arrow-left {
  position: absolute;
  top: 48%;
  left: 0;
  z-index: 2005;
  cursor: pointer;
}

.hide-arrow-right {
  position: absolute;
  top: 48%;
  right: 0;
  cursor: pointer;
  z-index: 2005;
}

.type-item-active {
  background-color: #1d2693;
}

.change2-scale {
  position: absolute;
  left: 70.2%;
  bottom: 80px;
  z-index: 99999;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/MmWl.vue